module.exports = __webpack_public_path__ + "static/media/arber.e1ca9c8d.png";